import React from 'react';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import LinearProgress from '@material-ui/core/LinearProgress';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import './Cards.css';

const url = 'https://masteryrace-api.vercel.app/api/summoner/graphData';
const urlIcons = 'https://ddragon.leagueoflegends.com/cdn/10.16.1/img/profileicon/';
const masteryIcon = 'https://raw.communitydragon.org/7.23/plugins/rcp-fe-lol-champion-mastery-notifications/global/default/assets/cm_rank_up/'
var original = [];

export default class Cards extends React.Component{
  constructor(props) {
    super(props);
    this.state = { 
      items : [],
      info: [],
      icons: [],
      isLoaded: false,
      sort: "",
    };
    this.sortAscending = this.sortAscending.bind(this);
    this.sortDescending = this.sortDescending.bind(this);
    this.sortNone = this.sortNone.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoaded: false });
    try{
      const response = await axios.get(url);
      this.setState({
        items: response.data
      });
      this.fillStateData();
      this.setState({
        isLoaded: true,
      });
      this.props.setLoaded2(true);
    }catch(err){
      console.log(err);
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps !== this.props) {
      this.setState({
        sort: this.props
      });
      if (this.props.sort === "HightoLow"){
        this.sortDescending();
      }else if(this.props.sort === "LowtoHigh"){
        this.sortAscending();
      }else if (this.props.sort === "None"){
        this.sortNone();
      }
    }
  }

  sortNone = () => {
    var pointsNone = [...original];
    this.setState({
      info: pointsNone
    });
  }

  sortAscending = () => {
    var pointsAscending = [...original];
    pointsAscending.sort(function (a, b) {
      return a.champPoints - b.champPoints;
    });
    this.setState({
      info: pointsAscending
    });
  }

  sortDescending = () => {
    var pointsDescending = [...original];
    pointsDescending.sort(function (a, b) {
      return b.champPoints - a.champPoints;
    });
    this.setState({
      info: pointsDescending
    });
  }

  async fillStateData(){
    original = [];
    for(var i = 0; i<this.state.items.data.length; i++){
      if (this.state.items.data[i].championLevel === undefined){
        this.state.info[i] = {
          summonerName: this.state.items.data[i].summ,
          icons: this.state.items.data[i].icon,
          level: 0,
          championPointsSinceLast: 0,
          championpointsUntilNext: 0,
          progress: 0,
          champPoints: 0,
        }
      }else{
        this.state.info[i] = {
          summonerName: this.state.items.data[i].summ,
          icons: this.state.items.data[i].icon,
          level: this.state.items.data[i].championLevel,
          championPointsSinceLast: this.state.items.data[i].championpointsSinceLast,
          championpointsUntilNext: this.state.items.data[i].championpointsUntilNext,
          progress: (this.state.items.data[i].championPoints / (this.state.items.data[i].championPoints + this.state.items.data[i].championpointsUntilNext))*100,
          champPoints: this.state.items.data[i].championPoints,
        }
      }
      original[i] = this.state.info[i];
    }
    Object.keys(this.state.items.data).forEach(key => this.state.icons.push(this.state.items.data[key].icon));
  }
  
  
  render(){
    if (this.state.isLoaded === false){
      return(<CircularProgress />);
    }else{
      return(
      
        <div className="Cards">
          <Grid
            container
            spacing={2}
            direction="row"
            justify="center"
            alignItems="flex-start"
            id = "cardgrid"
          >
            {this.state.icons.map((icons, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={icons}>
            <Card id = "card">
              <CardContent>
                <img src={urlIcons.concat(this.state.info[index].icons).concat('.png')} id = "summonerIcon" alt="summonerIcon" width="50" height="50" />
                <Typography variant="h6"component="h2">
                  {this.state.info[index].summonerName}
                </Typography>
                <Typography variant="body2"component="p">
                  {this.state.info[index].champPoints.toLocaleString()}
                  {" "} points
                </Typography>
                <Typography variant="subtitle2"component="p">
                  Mastery Level: 
                  {" "}
                  {this.state.info[index].level}
                </Typography>
                {this.state.info[index].level < 5 ?
                <Typography variant="subtitle1"component="p">
                  Progress to level
                  {" "}
                  {this.state.info[index].level + 1}
                  {" :"}
                </Typography>:
                <p></p>
                }
                {
                this.state.info[index].level < 5 ?
                <Typography variant="subtitle1"component="span">
                  {this.state.info[index].champPoints.toLocaleString()} {" / "} {(this.state.info[index].champPoints + this.state.info[index].championpointsUntilNext).toLocaleString()}
                  <LinearProgress variant="determinate" value={this.state.info[index].progress} />
                </Typography> 
                : <img src = {masteryIcon.concat(this.state.info[index].level).concat('.png')} alt= "Mastery7" id="completedMastery" width="40px" height="40px"></img>}
                {/* <Typography variant="subtitle1"component="p">
                {this.state.info[index].champPoints.toLocaleString()} {" / "} {(this.state.info[index].champPoints + this.state.info[index].championpointsUntilNext).toLocaleString()}
                </Typography>
                <LinearProgress variant="determinate" value={this.state.info[index].progress} /> */}
              </CardContent>
            </Card>
            </Grid>
            ))}
          </Grid>
        </div>  
      )
    } 
  }
}